import FooterDownload from '../FooterDownload/FooterDownload';
import styles from '../../property1-desktop.module.scss';
import Link from 'next/link';
import Image from 'next/image';

const SubFooter = () => {
  return (
    <section className={styles.subFooter}>
      <div className="container">
        <div className={styles.section2}>
          <div className={styles.footermenuParent}>
            <div className={styles.footermenu}>
              <div className={styles.aboutParent}>
                <Link href="/about" className={styles.footerLink}>
                  <h3 className={styles.jetCard}>About</h3>
                </Link>
                <div className={styles.aboutSubmenu}>
                  <Link href="/management" className={styles.footerLink}>
                    <div className={styles.management}>Management</div>
                  </Link>
                  <Link href="/jobs" className={styles.footerLink}>
                    <div className={styles.careers}>Careers</div>
                  </Link>
                  <Link
                    href="/hera-flight-race-team"
                    className={styles.footerLink}
                  >
                    <div className={styles.raceTeam}>Race Team</div>
                  </Link>
                </div>
              </div>
              <div className={styles.servicesParent}>
                <Link href="/services" className={styles.footerLink}>
                  <h3 className={styles.jetCard}>Services</h3>
                </Link>
                <div className={styles.servicesSubmenu}>
                  <Link
                    href="/aircraft-management"
                    className={styles.footerLink}
                  >
                    <div className={styles.aircraftManagement}>
                      Aircraft Management
                    </div>
                  </Link>
                  <Link href="/aircraft-sales" className={styles.footerLink}>
                    <div className={styles.aircraftSales}>Aircraft Sales</div>
                  </Link>
                </div>
              </div>
              <div className={styles.charterFlightsParent}>
                <Link href="/charter" className={styles.footerLink}>
                  <h3 className={styles.jetCard}>Charter Flights</h3>
                </Link>
                <div className={styles.charterSubmenu}>
                  <Link href="/empty-leg-flights" className={styles.footerLink}>
                    <div className={styles.emptyLegFlights}>
                      Empty Leg Flights
                    </div>
                  </Link>
                </div>
                <div className={styles.charterSubmenu}>
                  <Link
                    href="/private-jet-to-miami"
                    className={styles.footerLink}
                  >
                    <div className={styles.emptyLegFlights}>
                      Private Jet Charter Miami
                    </div>
                  </Link>
                </div>
                <div className={styles.charterSubmenu}>
                  <Link
                    href="/private-jet-to-los-angeles"
                    className={styles.footerLink}
                  >
                    <div className={styles.emptyLegFlights}>
                      Private Jet Charter Los Angeles
                    </div>
                  </Link>
                </div>
                <div className={styles.charterSubmenu}>
                  <Link
                    href="/private-jet-to-palm-beach"
                    className={styles.footerLink}
                  >
                    <div className={styles.emptyLegFlights}>
                      Private Jet Charter Palm Beach
                    </div>
                  </Link>
                </div>
                <div className={styles.charterSubmenu}>
                  <Link
                    href="/private-jet-to-monaco"
                    className={styles.footerLink}
                  >
                    <div className={styles.emptyLegFlights}>
                      Private Jet Charter Monaco
                    </div>
                  </Link>
                </div>
                <div className={styles.charterSubmenu}>
                  <Link
                    href="/private-jet-to-new-york"
                    className={styles.footerLink}
                  >
                    <div className={styles.emptyLegFlights}>
                      Private Jet Charter New York
                    </div>
                  </Link>
                </div>
              </div>
              <div className={styles.jetCardParent}>
                <Link
                  href="/hera-10-hour-s-jet-program"
                  className={styles.footerLink}
                >
                  <h3 className={styles.jetCard}>Jet Card 10 Hours</h3>
                </Link>
                <Link
                  href="/hera-jet-card-membership"
                  className={styles.footerLink}
                >
                  <h3 className={styles.jetCard}>Jet Card 25 Hours</h3>
                </Link>

                <Link href="/available-fleet" className={styles.footerLink}>
                  <h3 className={styles.availableFleet}>Available Fleet</h3>
                </Link>
                <Link href="/blog" className={styles.footerLink}>
                  <h3 className={styles.blogPress}>{`Blog & Press`}</h3>
                </Link>
                <Link href="/contact" className={styles.footerLink}>
                  <h3 className={styles.contacts2}>Contacts</h3>
                </Link>
              </div>
            </div>
            <FooterDownload property1="Desktop" />
          </div>
          <div className={styles.footerinfo}>
            <div className={styles.allwights}>
              © 2026 Hera Enterprises, LLC. All rights reserved
            </div>
            <div className={styles.links}>
              <Link href="/terms-of-service" className={styles.footerLink}>
                <div
                  className={styles.termsConditions}
                >{`Terms of Service`}</div>
              </Link>
              <div className={styles.dot} />
              <Link href="/privacy-policy" className={styles.footerLink}>
                <div className={styles.privacyPolicy}>Privacy Policy</div>
              </Link>
            </div>
            <Link
              href="https://eztechtonic.com"
              className={styles.footerLinkEzDesc}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.footerLinkEzDesc}>
                <div className={styles.innovatedBy}>Innovated by </div>
                <Image
                  width={66}
                  height={48}
                  sizes="100vw"
                  alt="Logo"
                  src="/img/footer/footerEZLogo.webp"
                />
              </div>
            </Link>
          </div>
          <div className={styles.footerLinkEzDescMobileParent}>
            <Link
              href="https://eztechtonic.com"
              className={styles.footerLinkEzDescMobile}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.footerLinkEzDescMobile}>
                <div className={styles.innovatedBy}>Innovated by </div>
                <Image
                  width={66}
                  height={48}
                  sizes="100vw"
                  alt="Logo"
                  src="/img/footer/footerEZLogo.webp"
                />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubFooter;
